import { object, string } from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import { PermissionsContext } from '../providers/permissions'
import { useKeycloak } from '@react-keycloak/web'
const PrivateRC = ({ children, permission = '', roles }) => {
  const { permissions } = useContext(PermissionsContext)
  const { keycloak } = useKeycloak()
  const [resource, scope] = permission.split('#')
  const [result, setResult] = useState(false)

  useEffect(() => {
    if (permissions !== null) {
      if (permissions.permissions.length === 0 && permissions.roles === 0) {
        keycloak.logout()
      } else {
        if (permission !== '') {
          if (resource && scope) {
            setResult(permissions.permissions[resource]?.includes(scope))
          } else {
            setResult(permissions.roles?.includes(roles))
          }
        } else {
          permissions?.roles?.includes(roles)
          setResult(permissions?.roles?.includes(roles))
        }
      }
    }
  }, [permissions])

  if (result) return children
}
PrivateRC.propTypes = {
  children: object,
  permission: string,
  roles: string
}

export default PrivateRC
